import * as React from "react";
import OrderListItemCard from "../../../../OrderListItemCard/Orders/components/OrderListItemCard/OrderListItemCard.js";
/* empty css                   */
const OrderListItem = ({ href, onClick, imageUrl, header, subtitle, labels }) => {
  return /* @__PURE__ */ React.createElement(
    OrderListItemCard,
    {
      header,
      subtitle,
      imagePath: imageUrl,
      href,
      onClick,
      labels
    }
  );
};
export {
  OrderListItem as default
};
//# sourceMappingURL=OrderListItem.js.map
